import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { InstallationId } from "@/features/sub-families/types";
import type { Nullable } from "@/types";

type State = {
    activeId: Nullable<InstallationId>;
    options: Record<InstallationId, string>;
};

const initialState: State = {
    activeId: null,
    options: {},
};

const slice = createSlice({
    name: "installations",
    initialState,
    reducers: {
        installationsSetOptionsAction: (state: State, action: PayloadAction<Record<InstallationId, string>>) => {
            state.options = action.payload;
        },
        installationsSelectAction: (state: State, action: PayloadAction<Nullable<InstallationId>>) => {
            state.activeId = action.payload;
        },
    },
});

export const { installationsSetOptionsAction, installationsSelectAction } = slice.actions;

export default slice.reducer;
